<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <rect class="filled" x="10.163" y="9.98" width="17.715" height="18.082" rx="1.108" fill="currentColor"/>
      <rect class="filled" x="36.122" y="9.98" width="17.715" height="18.082" rx="1.108" fill="currentColor"/>
      <rect class="filled" x="36.122" y="35.938" width="17.715" height="18.082" rx="1.108" fill="currentColor"/>
      <rect class="filled" x="10.163" y="35.938" width="17.715" height="18.082" rx="1.108" fill="currentColor"/>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
